export default function PlatformOfferLink({
  url,
  provider,
  title,
}: {
  url: string;
  provider?: string | null;
  title?: string;
}) {
  const labels: Record<string, string> = {
    airbnb: 'Airbnb',
    hometogo: 'HomeToGo',
    'fewo-direkt': 'FeWo-direkt',
    booking: 'Booking.com',
    unknown: 'Unbekannt',
  };
  const providerLabel = provider ? labels[provider] ?? provider : null;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex shrink-0 items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
      title={title}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-blue-500" />
      {providerLabel ? `Angebot von ${providerLabel}` : 'Auf HomeToGo ansehen'} &rarr;
    </a>
  );
}
